<template>
  <div>
    <div class="flex-right">
      <h2>学校管理</h2>
      <div class="flex-right-flex1"></div>
      <i-button type="primary" @click="edit(false)">新增</i-button>
    </div>
    <Table :columns="col" :data="data.list">
      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" @click="edit(row)">修改</i-button>
        <i-button type="error" style="margin-left: 10px" @click="deleteIt(row)">删除</i-button>
      </template>
      <template slot-scope="{ row }" slot="chn_name">
        {{ row.base_info.chn_name }}
      </template>
      <template slot-scope="{ row }" slot="en_name">
        {{ row.base_info.en_name }}
      </template>
    </Table>
    <div class="flex-right" style="margin-top: 10px">
      <Page show-sizer :total="data.total" :current="data.page" :page-size="data.size" @on-change="getData" />
    </div>
    <Drawer title="" width="86" v-model="showEdit" :closable="false">
      <Form :model="editObj" label-position="left" :label-width="100">
        <Row :gutter="32">
          <Divider>基础信息</Divider>
          <i-col span="8">
            <FormItem label="学校中文名">
              <i-input type="text" v-model="editObj.base_info.chn_name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="学校英文名">
              <i-input type="text" v-model="editObj.base_info.en_name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="地址">
              <i-input type="text" v-model="editObj.base_info.address"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="校徽">
              <uploadMainImg :srcData="editObj.base_info.logo" :keyNum="editObj._id" @change="changeLogo"></uploadMainImg>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="类型">
              <Select v-model="editObj.base_info.type" placeholder="选择类型">
                <Option value="public">公立</Option>
                <Option value="private">私立</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="国家">
              <Select v-model="editObj.base_info.country" placeholder="选择国家">
                <Option value="US">US</Option>
                <Option value="UK">UK</Option>
                <Option value="AUS">AUS</Option>
                <Option value="EUR">EUR</Option>
                <Option value="JAP">JAP</Option>
                <Option value="Other">Other</Option>
              </Select>
            </FormItem>
          </i-col>
          <Divider>学校概况</Divider>
          <i-col span="8">
            <FormItem label="综合排名">
              <i-input type="number" v-model="editObj.profile.total_ranking"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="商学院排名">
              <i-input type="number" v-model="editObj.profile.business_ranking"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="工程学院排名">
              <i-input type="number" v-model="editObj.profile.engineering_ranking"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="热门学科">
              <i-input type="text" v-model="editObj.profile.popular_subject"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="学费（$）">
              <i-input type="text" v-model="editObj.profile.tuition_fee"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="性质">
              <i-input type="text" v-model="editObj.profile.nature"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="城市/州">
              <i-input type="text" v-model="editObj.profile.city"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="学期">
              <i-input type="text" v-model="editObj.profile.term"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="住宿率">
              <i-input type="text" v-model="editObj.profile.accommodation_rate"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="4年毕业率">
              <i-input type="text" v-model="editObj.profile.graduation_rate"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="网址">
              <i-input type="text" v-model="editObj.profile.web_site"></i-input>
            </FormItem>
          </i-col>
          <Divider>学生信息</Divider>
          <i-col span="8">
            <FormItem label="学生总数">
              <i-input type="text" v-model="editObj.student_info.total_number_students"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="本科人数">
              <i-input type="text" v-model="editObj.student_info.number_of_undergraduates"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="研究生人数">
              <i-input type="text" v-model="editObj.student_info.number_of_graduate_students"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="师生比">
              <i-input type="text" v-model="editObj.student_info.teacher_student_ratio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="国际生比例">
              <i-input type="text" v-model="
                  editObj.student_info
                    .proportion_of_international_students_ratio
                "></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="中国学生比">
              <i-input type="text" v-model="editObj.student_info.chinese_student_ratio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="男女比例">
              <i-input type="text" v-model="editObj.student_info.gender_ratio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="毕业生起薪中值">
              <i-input type="text" v-model="
                  editObj.student_info.median_starting_salary_of_graduates
                "></i-input>
            </FormItem>
          </i-col>
          <Divider>申请录取情况</Divider>
          <i-col span="8">
            <FormItem label="总申请人数">
              <i-input type="text" v-model="editObj.apply.total_number_of_applicants"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="早申人数">
              <i-input type="text" v-model="editObj.apply.number_of_early_applicants"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="早申录取率">
              <i-input type="text" v-model="editObj.apply.early_application_admission_rate"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="早申录取率">
              <i-input type="text" v-model="editObj.apply.total_enrollment"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="总录取率">
              <i-input type="text" v-model="editObj.apply.total_admission_rate"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="总录取率排名">
              <i-input type="text" v-model="editObj.apply.ranking_of_total_admission_rate"></i-input>
            </FormItem>
          </i-col>
          <Divider>录取成绩范围</Divider>
          <i-col span="8">
            <FormItem label="ACT 25-75%">
              <i-input type="text" v-model="editObj.achievement_range.ACT25_75_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="ACT 30-36%">
              <i-input type="text" v-model="editObj.achievement_range.ACT_30_36_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="ACT 24-29%">
              <i-input type="text" v-model="editObj.achievement_range.ACT_24_29_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT 25-75%">
              <i-input type="text" v-model="editObj.achievement_range.SAT_25_75_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT 1400-1600">
              <i-input type="text" v-model="editObj.achievement_range.SAT_1400_1600"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT 1200-1399">
              <i-input type="text" v-model="editObj.achievement_range.SAT_1200_1399"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT 数学700-800">
              <i-input type="text" v-model="editObj.achievement_range.SAT_math_700_800"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT 数学600-699">
              <i-input type="text" v-model="editObj.achievement_range.SAT_math_600_699"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT EBRW 700-800">
              <i-input type="text" v-model="editObj.achievement_range.SAT_EBRW_700_800"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="SAT EBRW 600-699">
              <i-input type="text" v-model="editObj.achievement_range.SAT_EBRW_600_699"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="Class Rank 10%">
              <i-input type="text" v-model="editObj.achievement_range.class_rank_10_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="Class Rank 25%">
              <i-input type="text" v-model="editObj.achievement_range.class_rank_25_radio"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="GPA4.0">
              <i-input type="text" v-model="editObj.achievement_range.GPA_4_0"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="GPA3.75-3.99">
              <i-input type="text" v-model="editObj.achievement_range.GPA_3_75_3_99"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="TOEFL">
              <i-input type="text" v-model="editObj.achievement_range.total"></i-input>
            </FormItem>
          </i-col>
          <Divider>申请轮次（最新的一年）</Divider>
          <i-col span="8">
            <FormItem label="REA">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.REA"></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="EA1">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.EA1"></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="EA2">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.EA2"></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="ED">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.ED"></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="ED2">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.ED2"></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="RD">
              <DatePicker type="date" placeholder="选择时间" style="width: 100%" format="yyyy-MM-dd" v-model="editObj.round.RD"></DatePicker>
            </FormItem>
          </i-col>
          <Divider>招生因素</Divider>
          <i-col span="8">
            <FormItem label="最重要">
              <Select v-model="editObj.factors.most_important" multiple placeholder="选择类型">
                <Option v-for="(option, index) in factorsOption" :value="option" :key="index">{{ option }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="比较重要">
              <Select v-model="editObj.factors.second_important" multiple placeholder="选择类型">
                <Option v-for="(option, index) in factorsOption" :value="option" :key="index">{{ option }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="考虑">
              <Select v-model="editObj.factors.consider" multiple placeholder="选择类型">
                <Option v-for="(option, index) in factorsOption" :value="option" :key="index">{{ option }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="不考虑">
              <Select v-model="editObj.factors.not_consider" multiple placeholder="选择类型">
                <Option v-for="(option, index) in factorsOption" :value="option" :key="index">{{ option }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <Divider>申请要求</Divider>
          <i-col span="8">
            <FormItem label="文书">
              <Checkbox v-model="editObj.application_requirements.isNeedpage">{{
                editObj.application_requirements.isNeedpage ? "需要" : "不需要"
                }}</Checkbox>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="推荐信">
              <Checkbox v-model="editObj.application_requirements.recommendation">{{
                editObj.application_requirements.recommendation ? "需要" : "不需要"
                }}</Checkbox>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="TOEFL/IELTS">
              <i-input type="text" v-model="editObj.application_requirements.TOEFL_IELTS"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="成绩单">
              <Checkbox v-model="editObj.application_requirements.isNeed_school_report">{{
                editObj.application_requirements.isNeed_school_report
                ? "需要"
                : "不需要"
                }}</Checkbox>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="课程要求">
              <Checkbox v-model="editObj.application_requirements.course_requirements">{{
                editObj.application_requirements.course_requirements
                ? "需要"
                : "不需要"
                }}</Checkbox>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="考试要求">
              <i-input type="text" v-model="
                  editObj.application_requirements.examination_requirements
                "></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="标化">
              <Checkbox v-model="editObj.application_requirements.standarad">{{
                editObj.application_requirements.standarad ? "强制" : "不强制"
                }}</Checkbox>
            </FormItem>
          </i-col>
          <Divider>其他</Divider>
          <i-col span="8">
            <FormItem label="APP System">
              <Select v-model="editObj.other.appSystem" placeholder="选择app">
                <Option value="CA">CA</Option>
                <Option value="UC">UC</Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
      </Form>
      <div class="flex-right" style="margin: 0" slot="header">
        <h3>修改/新增学校</h3>
        <div class="flex-right-flex1"></div>
        <i-button type="default" @click="showEdit = false">关闭</i-button>
        <i-button type="primary" style="margin-left: 10px" @click="save">保存</i-button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import uploadMainImg from "@/components/uploadMainImg.vue";
export default {
  components: { uploadMainImg },
  data() {
    return {
      col: [{
          title: "chn_name",
          slot: "chn_name",
        },
        {
          title: "en_name",
          slot: "en_name",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      data: {},
      showEdit: false,
      editObj: {
        base_info: {},
        profile: {},
        student_info: {},
        apply: {},
        achievement_range: {},
        round: {},
        factors: {},
        application_requirements: {},
        other: {},
      },
      factorsOption: ["talent", "gpa", "volunteer"],
    };
  },
  methods: {
    async getData(page = 1) {
      let res = await this.api({
        url: "/school/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          page: page,
          size: 10,
        },
      });
      this.data = res;
    },

    edit(val) {
      if (!val) {
        this.editObj = {
          base_info: {},
          profile: {},
          student_info: {},
          apply: {},
          achievement_range: {},
          round: {},
          factors: {},
          application_requirements: {},
          other: {},
        };
      } else {
        this.editObj = val;
        if (this.editObj.round && this.editObj.round.REA) {
          this.editObj.round.REA = this.$moment(this.editObj.round.REA).format(
            "YYYY-MM-DD"
          );
        }
        if (this.editObj.round && this.editObj.round.EA1) {
          this.editObj.round.EA1 = this.$moment(this.editObj.round.EA1).format(
            "YYYY-MM-DD"
          );
        }
        if (this.editObj.round && this.editObj.round.EA2) {
          this.editObj.round.EA2 = this.$moment(this.editObj.round.EA2).format(
            "YYYY-MM-DD"
          );
        }
        if (this.editObj.round && this.editObj.round.ED) {
          this.editObj.round.ED = this.$moment(this.editObj.round.ED).format(
            "YYYY-MM-DD"
          );
        }
        if (this.editObj.round && this.editObj.round.ED2) {
          this.editObj.round.ED2 = this.$moment(this.editObj.round.ED2).format(
            "YYYY-MM-DD"
          );
        }
        if (this.editObj.round && this.editObj.round.RD) {
          this.editObj.round.RD = this.$moment(this.editObj.round.RD).format(
            "YYYY-MM-DD"
          );
        }
      }
      this.showEdit = true;
    },

    async save() {
      let editObj = this.editObj;

      await this.api({
        url: "/school/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          _id: editObj._id,
          info: JSON.stringify(this.editObj),
        },
      });

      this.$Message.success("保存成功");
      this.getData();
      this.showEdit = false;
    },

    async deleteIt(item) {
      this.$Modal.confirm({
        title: "确定要删除:" + item.base_info.chn_name + "?",
        content: "删除后将不可恢复",
        closable: true,
        cancelText: "取消",
        onOk: async () => {
          await this.api({
            url: "/school/deleteIt",
            method: "delete",
            params: {
              token: this.$store.getters.token,
              ttoken: this.$store.getters.ttoken,
            },
            data: {
              _id: item._id,
            },
          });

          this.$Message.success("删除成功");
          this.getData();
        },
        onCancel: () => {},
      });
    },

    changeLogo(val) {
      // console.log(val)
      this.editObj.base_info.logo = val;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>